import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetPerformanceScoreState, getPerformanceScore } from "../../../store/performanceScore/action";
import { resetPositionState, getPosition } from "../../../store/position/action";
import { resetClientState, getClient } from "../../../store/client/action";
import { resetPerformanceAppraisalDetailState, getPerformanceAppraisalDetail as onGetPerformanceAppraisalDetails, addNewPerformanceAppraisalDetail as onAddNewPerformanceAppraisalDetail, updatePerformanceAppraisalDetail as onUpdatePerformanceAppraisalDetail, deletePerformanceAppraisalDetail as onDeletePerformanceAppraisalDetail, getPerformanceAppraisalDetailLoading } from "../../../store/performanceAppraisalDetail/action";
import { getPerformanceAppraisal as onGetPerformanceAppraisals, addNewPerformanceAppraisal as onAddNewPerformanceAppraisal, updatePerformanceAppraisal as onUpdatePerformanceAppraisal, deletePerformanceAppraisal as onDeletePerformanceAppraisal, getPerformanceAppraisalLoading, resetPerformanceAppraisalState } from "../../../store/performanceAppraisal/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const PerformanceAppraisal = () => {
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [companyName, setCompanyName] = useState({});
  const [clientName, setClientName] = useState({});
  const [detailList, setDetailList] = useState([]);
  const [searchValueSecond, setSearchValueSecond] = useState([]);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, performanceAppraisals, isPerformanceAppraisalCreated, isPerformanceAppraisalSuccess, loading, error, performanceAppraisalDetails, performanceAppraisalDetailLoading, isPerformanceAppraisalDetailCreated, isPerformanceAppraisalDetailSuccess, companies, companyLoading, performanceScores, performanceScoreLoading, positions, positionLoading, clients, clientLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    performanceAppraisals: state.PerformanceAppraisal.performanceAppraisals,
    isPerformanceAppraisalCreated: state.PerformanceAppraisal.isPerformanceAppraisalCreated,
    isPerformanceAppraisalSuccess: state.PerformanceAppraisal.isPerformanceAppraisalSuccess,
    loading: state.PerformanceAppraisal.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.PerformanceAppraisal.error,
    performanceAppraisalDetails: state.PerformanceAppraisalDetail.performanceAppraisalDetails,
    performanceAppraisalDetailLoading: state.PerformanceAppraisalDetail.loading,
    isPerformanceAppraisalDetailCreated: state.PerformanceAppraisalDetail.isPerformanceAppraisalDetailCreated,
    isPerformanceAppraisalDetailSuccess: state.PerformanceAppraisalDetail.isPerformanceAppraisalDetailSuccess,
    performanceScores: state.PerformanceScore.performanceScores,
    performanceScoreLoading: state.PerformanceScore.loading,
    positions: state.Position.positions,
    positionLoading: state.Position.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [performanceAppraisalList, setPerformanceAppraisalList] = useState([]);
  const [performanceAppraisal, setPerformanceAppraisal] = useState([]);
  const [appraisalDetailAddedId, setAppraisalDetailAddedId] = useState(0);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [performanceAppraisalDetail, setPerformanceAppraisalDetail] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [performanceScoreList, setPerformanceScoreList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [positionList, setPositionList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const ref = useRef(null);

  const defaultdate = () => {
    return moment(new Date()).format("YYYY/MM/DD HH:mm:ss").toString();
  };

  const onClickDelete = (performanceAppraisal) => {
    setPerformanceAppraisal(performanceAppraisal);
    setDeleteModal(true);
  };

  const onClickDeleteDetail = (performanceAppraisalDetail) => {
    setPerformanceAppraisalDetail(performanceAppraisalDetail);
    setDeleteModalDetail(true);
  };

  const handleDeletePerformanceAppraisal = () => {
    if (performanceAppraisal) {
      dispatch(onDeletePerformanceAppraisal(performanceAppraisal));
      setDeleteModal(false);
    }
  };

  const handleDeletePerformanceAppraisalDetail = () => {
    if (performanceAppraisalDetail) {
      setAppraisalDetailAddedId(performanceAppraisalDetail.appraisalId);
      dispatch(onDeletePerformanceAppraisalDetail(performanceAppraisalDetail));
      setDeleteModalDetail(false);
    }
  };

  const onClickApprove = (employee) => {
    setPerformanceAppraisal(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredPerformanceAppraisals = performanceAppraisals;
      if (type !== "all") {
        filteredPerformanceAppraisals = performanceAppraisals.filter((performanceAppraisal) => performanceAppraisal.kpipa_status.name === type);
      }
      setPerformanceAppraisalList(filteredPerformanceAppraisals);
    }
  };

  useEffect(() => {
    if (companySelected) {
      dispatch(resetPerformanceAppraisalState());
      dispatch(onGetPerformanceAppraisals({ companyId: companySelected?.value ?? "" }));
    }
  }, [companySelected]);

  useEffect(() => {
    if (!isEmpty(performanceAppraisals)) {
      setIsEdit(false);
      let filteredPerformanceAppraisals = performanceAppraisals;
      if (activeTypeTab !== "all") {
        filteredPerformanceAppraisals = performanceAppraisals.filter((performanceAppraisal) => performanceAppraisal.kpipa_status.name === activeTypeTab);
      }
      setPerformanceAppraisalList(filteredPerformanceAppraisals);
      let current = 0;
      if (appraisalDetailAddedId !== 0) {
        performanceAppraisals.forEach((obj, i) => {
          if (obj.id === appraisalDetailAddedId) current = i;
        });
      }
      setInfo(performanceAppraisals[current]);
    }
  }, [performanceAppraisals, appraisalDetailAddedId]);

  useEffect(() => {
    if (isPerformanceAppraisalDetailCreated) {
      dispatch(resetPerformanceAppraisalDetailState());
      dispatch(resetPerformanceAppraisalState());
      dispatch(onGetPerformanceAppraisals());
    }
  }, [dispatch, isPerformanceAppraisalDetailCreated]);

  // useEffect(() => {
  //   if (companies && !companies.length) {
  //     dispatch(resetCompanyState());
  //     dispatch(getCompany());
  //   }
  // }, [dispatch, companies]);

  useEffect(() => {
    if (userType !== "admin") {
      if (companyName) {
        dispatch(getPosition({ companyId: companyName.value, status: 2 }));
      }
    }
  }, [companyName, userType, dispatch]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(positions)) {
      var data = [];
      var opt = [];
      positions.forEach((item, key) => {
        const position_name = item.name;
        const departmentId = item.departmentId;
        const name = item.position_department && item.position_department.name;
        const id = item.id;
        var obj = {
          label: position_name + ", " + name,
          value: id,
          positionId: id,
          position_name: position_name,
          departmentId: departmentId,
          name: name,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPositionList(data);
    }
  }, [positions]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(performanceScores)) {
      var data = [];
      var opt = [];
      performanceScores.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPerformanceScoreList(data);
    }
  }, [performanceScores]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setPerformanceAppraisal(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handlePerformanceAppraisalClick = useCallback(
    (arg) => {
      const data = arg;
      setPerformanceAppraisal({
        id: data.id,
        name: data.name,
        percentage: data.percentage,
        type: {
          label: data.type,
          value: data.type,
        },
        company: {
          label: data.kpipa_company.name,
          value: data.kpipa_company.id,
        },
        client: {
          label: data.kpipa_client.name,
          value: data.kpipa_client.id,
        },
        position: {
          label: data.kpipa_position.name,
          value: data.kpipa_position.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setPerformanceAppraisalDetail(null);
      setPerformanceAppraisal(null);
      setPerformanceScoreList([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handlePerformanceAppraisalDetailClick = useCallback(
    (arg) => {
      const data = arg;

      setPerformanceAppraisalDetail({
        id: data.id,
        appraisalId: data.appraisalId,
        perspective: data.perspective,
        target: data.target,
        description: data.description,
        indicator: data.indicator,
        percentage_detail: data.percentage,
        score: data.kpipad_ps && {
          label: data.kpipad_ps.name,
          value: data.kpipad_ps.id,
        },
      });

      setIsEditDetail(true);
      toggleDetail();
    },
    [toggleDetail]
  );

  const columns = useMemo(
    () => [
      {
        Header: " ",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              {cellProps.row.original.statusId === 1 ? (
                <button
                  className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : userRole && userRole.split(",").indexOf("approvePerformanceAppraisal") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : "btn-label btn btn-sm btn-soft-success fs-12 me-0 d-none"}
                  onClick={() => {
                    let data = cellProps.row.original;
                    onClickApprove(data);
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                  Approve
                </button>
              ) : (
                ""
              )}
              <Link
                to="#"
                className="btn-icon btn btn-sm btn-light"
                onClick={() => {
                  setInfo(cellProps.row.original);
                  ref.current?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                <i className="ri-eye-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={userType === "admin" ? "btn-icon btn btn-sm btn-light edit-item-btn" : userRole && userRole.split(",").indexOf("updatePerformanceAppraisal") !== -1 ? "btn-icon btn btn-sm btn-light edit-item-btn" : "btn-icon btn btn-sm btn-light edit-item-btn d-none"}
                onClick={() => {
                  handlePerformanceAppraisalClick(cellProps.row.original);
                }}
              >
                <i className="ri-edit-2-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={userType === "admin" ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : userRole && userRole.split(",").indexOf("deletePerformanceAppraisal") !== -1 ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"}
                onClick={() => {
                  const performanceAppraisalData = cellProps.row.original;
                  onClickDelete(performanceAppraisalData);
                }}
              >
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Link>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Tipe",
        accessor: "type",
        filterable: true,
      },
      {
        Header: "Posisi",
        accessor: "kpipa_position.position_name",
        filterable: true,
      },
      {
        Header: "% Value",
        accessor: "percentage",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "kpipa_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
    ],
    [handlePerformanceAppraisalClick, userType, userRole]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: performanceAppraisalList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const columnsSecond = useMemo(
    () => [
      {
        Header: " ",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <Link
                to="#"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-light edit-item-btn" : userRole && userRole.split(",").indexOf("updatePerformanceAppraisal") !== -1 ? "btn-icon btn btn-sm btn-light edit-item-btn" : "btn-icon btn btn-sm btn-light edit-item-btn d-none"}
                onClick={() => {
                  handlePerformanceAppraisalDetailClick(cellProps.row.original);
                }}
              >
                <i className="ri-edit-2-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : userRole && userRole.split(",").indexOf("deletePerformanceAppraisal") !== -1 ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"}
                onClick={() => {
                  const productOptionData = cellProps.row.original;
                  onClickDeleteDetail(productOptionData);
                }}
              >
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Link>
            </div>
          );
        },
      },
      {
        Header: "Perspektif",
        accessor: "perspective",
        filterable: true,
      },
      {
        Header: "Work Goal",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div>
              <p className="fw-semibold mb-1">{cellProps.row.original.target}</p>
              <p className="mb-0">{cellProps.row.original.description}</p>
            </div>
          );
        },
      },
      {
        Header: "Indikator, Measures dan Target",
        accessor: "indicator",
        filterable: true,
      },
      {
        Header: "% Weight",
        accessor: "percentage",
        filterable: true,
      },
      {
        Header: "Skor",
        accessor: "kpipad_ps.name",
        filterable: true,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [info]
  );

  const {
    getTableProps: getTablePropsSecond,
    getTableBodyProps: getTableBodyPropsSecond,
    headerGroups: headerGroupsSecond,
    page: pageSecond,
    prepareRow: prepareRowSecond,
    canPreviousPage: canPreviousPageSecond,
    canNextPage: canNextPageSecond,
    pageOptions: pageOptionsSecond,
    gotoPage: gotoPageSecond,
    nextPage: nextPageSecond,
    previousPage: previousPageSecond,
    setPageSize: setPageSizeSecond,
    preGlobalFilteredRows: preGlobalFilteredRowsSecond,
    setGlobalFilter: setGlobalFilterSecond,
    state: { pageIndex: pageIndexSecond, pageSize: pageSizeSecond },
  } = useTable(
    {
      columns: columnsSecond,
      data: detailList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const onChangeInSelectSecond = (event) => {
    setPageSizeSecond(Number(event.target.value));
  };

  const onChangeInInputSecond = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPageSecond(page);
  };

  const onChangeSecond = useAsyncDebounce((value) => {
    setGlobalFilterSecond(value || undefined);
  }, 200);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  const handleApproveAppraisal = () => {
    if (performanceAppraisal) {
      performanceAppraisal.setApprove = true;
      dispatch(onUpdatePerformanceAppraisal(performanceAppraisal));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (performanceAppraisal && performanceAppraisal.name) ?? "",
      type: performanceAppraisal && performanceAppraisal.type,
      position: performanceAppraisal && performanceAppraisal.position,
      percentage: (performanceAppraisal && performanceAppraisal.percentage) || 0,
      client: (performanceAppraisal && performanceAppraisal.client) || clientSelected,
      company: (performanceAppraisal && performanceAppraisal.company) || companySelected,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Appraisal Name").nullable(true),
      position: Yup.object().required("Please Enter Position Name").nullable(true),
      company: Yup.object().required("Please Enter Company").nullable(true),
      type: Yup.object().required("Please Enter Appraisal Type").nullable(true),
      percentage: Yup.string().required("Please Enter Percentage Value").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getPerformanceAppraisalLoading());
      if (isEdit) {
        const updatePerformanceAppraisal = {
          id: performanceAppraisal ? performanceAppraisal.id : 0,
          name: values.name,
          type: values.type.value,
          percentage: values.percentage,
          positionId: values.position.value,
          companyId: values.company.value,
          statusId: 2,
          clientId: values.client.value,
        };
        dispatch(onUpdatePerformanceAppraisal(updatePerformanceAppraisal));
        validation.resetForm();
      } else {
        const newPerformanceAppraisal = {
          name: values.name,
          type: values.type.value,
          percentage: values.percentage,
          positionId: values.position.value,
          companyId: values.company.value,
          statusId: 2,
          clientId: values.client.value,
        };
        dispatch(onAddNewPerformanceAppraisal(newPerformanceAppraisal));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationDetail = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      appraisalId: (performanceAppraisalDetail && performanceAppraisalDetail.appraisalId) || (performanceAppraisal && performanceAppraisal.id),
      score: performanceAppraisalDetail && performanceAppraisalDetail.score,
      perspective: (performanceAppraisalDetail && performanceAppraisalDetail.perspective) ?? "",
      target: (performanceAppraisalDetail && performanceAppraisalDetail.target) ?? "",
      description: (performanceAppraisalDetail && performanceAppraisalDetail.description) ?? "",
      indicator: (performanceAppraisalDetail && performanceAppraisalDetail.indicator) ?? "",
      percentage_detail: (performanceAppraisalDetail && performanceAppraisalDetail.percentage_detail) || 0,
    },
    validationSchema: Yup.object({
      score: Yup.object().required("Please Enter Score Value").nullable(true),
      perspective: Yup.string().required("Please Enter Perspective").nullable(true),
      target: Yup.string().required("Please Enter Target").nullable(true),
      indicator: Yup.string().required("Please Enter Indicator").nullable(true),
      percentage_detail: Yup.string().required("Please Enter Percentage To").nullable(true),
    }),
    onSubmit: (values) => {
      setAppraisalDetailAddedId(values.appraisalId);
      dispatch(getPerformanceAppraisalLoading());
      if (isEditDetail) {
        const updatePerformanceAppraisalDetail = {
          id: performanceAppraisalDetail ? performanceAppraisalDetail.id : 0,
          scoreId: values.score.value,
          target: values.target,
          description: values.description,
          perspective: values.perspective,
          indicator: values.indicator,
          percentage: values.percentage_detail,
          appraisalId: values.appraisalId,
        };
        dispatch(onUpdatePerformanceAppraisalDetail(updatePerformanceAppraisalDetail));
        validationDetail.resetForm();
      } else {
        const newPerformanceAppraisalDetail = {
          scoreId: values.score.value,
          description: values.description,
          target: values.target,
          perspective: values.perspective,
          indicator: values.indicator,
          percentage: values.percentage_detail,
          appraisalId: values.appraisalId,
        };
        dispatch(onAddNewPerformanceAppraisalDetail(newPerformanceAppraisalDetail));
        validationDetail.resetForm();
      }
      toggleDetail();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeletePerformanceAppraisalDetail(element.value));
    });
    checkall.checked = false;
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetPerformanceAppraisals(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setPerformanceAppraisalList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetPerformanceAppraisalState());
    dispatch(onGetPerformanceAppraisals({ companyId: companySelected?.value ?? "" }));
  };

  useEffect(() => {
    if (info && info.kpipa_detail) {
      setDetailList(info.kpipa_detail);
    }
  }, [info]);

  document.title = "Panduan Penilaian | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ApproveModal data={performanceAppraisal && performanceAppraisal.contract_employee ? performanceAppraisal.contract_employee.name : ""} show={approveModal} onApproveClick={handleApproveAppraisal} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeletePerformanceAppraisal} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal show={deleteModalDetail} onDeleteClick={handleDeletePerformanceAppraisalDetail} onCloseClick={() => setDeleteModalDetail(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Guideline" pageTitle="Panduan Penilaian" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createPerformanceAppraisal") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setPerformanceAppraisal("");
                setIsEdit(false);
                toggle();
              }}
            >
              <i className=" ri-star-line me-1 align-bottom fs-14"></i>Tambah
            </button>
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className=" ri-star-line me-1 align-bottom fs-14"></i>SEMUA PANDUAN PENILAIAN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={9}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Panduan Penilaian" : "Tambah Panduan Penilaian"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Appraisal Name" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>

                          <div className="mb-3 col-lg-12`">
                            <Label htmlFor="type" className="form-label">
                              Tipe Penilaian{" "}
                            </Label>
                            <Select
                              name="type"
                              placeholder="Select Type"
                              value={validation.values.type}
                              onChange={(e) => {
                                validation.setFieldValue("type", e);
                              }}
                              options={[
                                {
                                  options: [
                                    { label: "KPI", value: "KPI" },
                                    { label: "360", value: "360" },
                                  ],
                                },
                              ]}
                            ></Select>
                            {validation.touched.type && validation.errors.type ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.type}
                              </small>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company" className="form-label">
                              Perusahaan{" "}
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              placeholder="Enter Company"
                              value={validation.values.company}
                              isDisabled={userType === "admin" || userType === "client" || userType === "company" ? false : true}
                              onChange={(e) => {
                                dispatch(setBranchSelect(null));
                                dispatch(setCompanySelect(e));
                                validation.setFieldValue("company", e);
                                setPositionList([]);
                                dispatch(resetPositionState());
                                dispatch(getPosition({ companyId: e.value, status: 2 }));
                              }}
                              onInputChange={(e) => {
                                // handleCompany(e);
                              }}
                              options={companyList}
                            ></Select>
                            {validation.touched.company && validation.errors.company ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.company}
                              </small>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="position" className="form-label">
                              Posisi{" "}
                              {positionLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}{" "}
                            </Label>
                            <Select
                              name="position"
                              value={validation.values.position}
                              placeholder="Enter Position"
                              onChange={(e) => {
                                validation.setFieldValue("position", e);
                              }}
                              options={positionList}
                              invalid={validation.touched.position && validation.errors.position ? true : false}
                            ></Select>
                            {validation.touched.position && validation.errors.position ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.position}
                              </p>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="percentage-field" className="form-label">
                              % Value{" "}
                            </Label>
                            <Input name="percentage" id="percentage-field" className="form-control" placeholder="Enter % Value" type="number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.percentage} invalid={validation.touched.percentage && validation.errors.percentage ? true : false} />
                            {validation.touched.percentage && validation.errors.percentage ? <FormFeedback type="invalid">{validation.errors.percentage}</FormFeedback> : null}
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {!!isEditDetail ? "Ubah Detail Penilaian" : "Tambah Detail Penilaian"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationDetail.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3">
                          <Label htmlFor="perspective-field" className="form-label">
                            Perspektif
                          </Label>
                          <Input name="perspective" id="perspective-field" className="form-control" placeholder="Enter Perspective" type="text" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.perspective} invalid={validationDetail.touched.perspective && validationDetail.errors.perspective ? true : false} />
                          {validationDetail.touched.perspective && validationDetail.errors.perspective ? <FormFeedback type="invalid">{validationDetail.errors.perspective}</FormFeedback> : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="target-field" className="form-label">
                            Work Goal
                          </Label>
                          <Input name="target" id="target-field" className="form-control" placeholder="Enter Goal" type="text" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.target} invalid={validationDetail.touched.target && validationDetail.errors.target ? true : false} />
                          {validationDetail.touched.target && validationDetail.errors.target ? <FormFeedback type="invalid">{validationDetail.errors.target}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="description-field" className="form-label">
                            Keterangan Work Goal
                          </Label>
                          <Input name="description" id="description-field" rows="4" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.description} />
                        </div>
                        <div className="mb-3 col-lg-4">
                          <Label htmlFor="percentage_detail-field" className="form-label">
                            % Performance Weight{" "}
                          </Label>
                          <Input name="percentage_detail" id="percentage_detail-field" className="form-control" placeholder="Enter Value To" type="number" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.percentage_detail} invalid={validationDetail.touched.percentage_detail && validationDetail.errors.percentage_detail ? true : false} />
                          {validationDetail.touched.percentage_detail && validationDetail.errors.percentage_detail ? <FormFeedback type="invalid">{validationDetail.errors.percentage_detail}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col-lg-8">
                          <Label htmlFor="score" className="form-label">
                            Tipe Skor{" "}
                            {performanceScoreLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="score"
                            placeholder="Enter Score"
                            value={validationDetail.values.score}
                            onChange={(e) => {
                              validationDetail.setFieldValue("score", e);
                            }}
                            options={performanceScoreList}
                          ></Select>
                          {validationDetail.touched.score && validationDetail.errors.score ? (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.score}
                            </small>
                          ) : null}
                        </div>

                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="indicator-field" className="form-label">
                            Indikator, Measures dan Target
                          </Label>
                          <Input name="indicator" id="indicator-field" rows="6" className="form-control" placeholder="Enter Indicator, Measures and Targets" type="textarea" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.indicator} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalDetail(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={12}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <h5 className="text-uppercase mb-2 flex-grow-1">{info.name && info.kpipa_position ? info.name + " - " + info.kpipa_position.name : " - "}</h5>
                <div className="flex-shrink-0">
                  <button
                    type="button"
                    className={userType === "admin" ? "btn btn-success add-btn" : userRole && userRole.split(",").indexOf("createPerformanceAppraisalDetail") !== -1 ? "btn btn-success add-btn" : "btn btn-success add-btn"}
                    id="create-btn"
                    onClick={(e) => {
                      setPerformanceAppraisal(info);
                      dispatch(resetPerformanceScoreState());
                      dispatch(
                        getPerformanceScore({
                          companyId: info.kpipa_company.id,
                        })
                      );
                      setIsEditDetail(false);
                      toggleDetail();
                      e.preventDefault();
                    }}
                  >
                    <i className="ri-list-check label-icon align-middle fs-13 me-1"></i>
                    Tambah Detail
                  </button>
                  <button className={userType === "admin" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deletePerformanceAppraisalDetail") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
                    <i className="ri-delete-bin-5-line me-1 align-bottom fs-13"></i>
                  </button>
                </div>
              </div>
              <div className="card-body">
                <Row>
                  <CardBody className="border border-top-0 border-end-0 border-start-0">
                    <form>
                      <Row>
                        <Col sm={2}>
                          <div className="me-2 mb-2">
                            <select className="form-select" value={pageSizeSecond} onChange={onChangeInSelectSecond}>
                              {[10, 50, 100, 250, 500].map((pageSizeSecond) => (
                                <option key={pageSizeSecond} value={pageSizeSecond}>
                                  {pageSizeSecond}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={4}>
                          <div className="search-box me-2 mb-2 d-inline-block col-12">
                            <input
                              onChange={(e) => {
                                setSearchValueSecond(e.target.value);
                                onChangeSecond(e.target.value);
                              }}
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              placeholder={`Cari...`}
                              value={searchValueSecond ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Row>
                <div className="table-responsive table-card mb-1">
                  <Table hover {...getTablePropsSecond()} className="align-middle table-nowrap">
                    <thead className="table-light">
                      {headerGroupsSecond.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>

                    <tbody {...getTableBodyPropsSecond()}>
                      {pageSecond.map((row) => {
                        prepareRowSecond(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                  <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button color="light" onClick={previousPageSecond} disabled={!canPreviousPageSecond}>
                        {"<"}
                      </Button>
                    </div>
                  </Col>
                  <Col className="col-md-auto d-none d-md-block">
                    Halaman {pageIndex + 1} dari {pageOptions.length}
                  </Col>
                  <Col className="col-md-auto">
                    <Input type="number" min={1} style={{ width: 70 }} max={pageOptionsSecond.length} defaultValue={pageIndexSecond + 1} onChange={onChangeInInputSecond} />
                  </Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button className="btn btn-light" onClick={nextPageSecond} disabled={!canNextPageSecond}>
                        {">"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PerformanceAppraisal;
